<section class="section">
	<ul class="breadcrumb breadcrumb-style ">
		<li class="breadcrumb-item">
			<h4 class="page-title m-b-0">Support Ticket</h4>
		</li>
		<li class="breadcrumb-item">
			<a routerLink="/dashboard">
				<i data-feather="home"></i></a>
		</li>
		<li class="breadcrumb-item active">Support Ticket List</li>
	</ul>

	<div class="card">
		<div class="card-header">
			<div class="ticket-section">
				<div class="col-3 col-md-3 col-xl-2 tile tab-primary active-filter" id="new-counts"
					(click)="selectDisplay($event,'new-counts')">
					<div class="card-header-details fl">
						<h6 class="m-b-5 text-left">New</h6>
						<h4 class="text-left"><span>{{counts.new}}</span>
						</h4>
					</div>
				</div>

				<div class="col-3 col-md-3 col-xl-2 tile tab-success" id="open-counts"
					(click)="selectDisplay($event,'open-counts')">
					<div class="card-header-details fl">
						<h6 class="m-b-5 text-left">Open</h6>
						<h4 class="text-left"><span>{{counts.open}}</span>
						</h4>
					</div>
				</div>

				<div class="col-3 col-md-3 col-xl-2 tile tab-warning " id="queue-counts"
					(click)="selectDisplay($event,'queue-counts')">
					<div class="card-header-details fl">
						<h6 class="m-b-5 text-left">In Progress</h6>
						<h4 class="text-left"><span>{{counts.in_progress}}</span>
						</h4>
					</div>
				</div>
				<div class="col-3 col-md-3 col-xl-2 tile tab-danger" id="close-counts"
					(click)="selectDisplay($event,'close-counts')">
					<div class="card-header-details fl">
						<h6 class="m-b-5 text-left">Resolved</h6>
						<h4 class="text-left"><span>{{counts.resolved}}</span>
						</h4>
					</div>
				</div>
			</div>
			<button type="submit" style="width: 150px;" class="btn btn-success" (click)="createticket()"><i
					class="fas fa-plus-circle"></i> Create Tickets</button>
			<a routerLink="/support-ticket" style="width: 170px;padding: 5px 0px;position: absolute;right: 12px;top: -65px;" class="btn btn-default btn-icon ping-bg-clr icon-left">
				<i class="fas fa-headset"></i> Old Support Ticket
			</a>
		</div>

	</div>
</section>

<!-- Create Ticket Modal -->
<div class="modal fade" id="addNewPopup" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
	aria-hidden="true">

	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
		<div class="modal-content addcustomernewallcss">
			<div class="modal-header">
				<h1 class="modal-title" id="exampleModalLongTitle">Create Tickets
				</h1>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>

			</div>
			<div class="modal-body mousepoint">
				<form class="deal-register-form" [formGroup]="createinformation">

					<div class="form-group">
						<label for="partner-name">From</label>
						<input type="text" class="form-control" id="partner-name" formControlName="fromticket" readonly>
						<div class="error-message message-small"
							*ngIf="!createinformation.get('fromticket').valid && createinformation.get('fromticket').touched">
							Please enter Name
						</div>
					</div>
					<div class="form-group">
						<label for="partner-country">Country </label>
						<select name="country" id="sales_r" class="form-control" formControlName="country">
							<option [ngValue]="null" selected>Select Country</option>
							<option *ngFor="let con of countryList" value="{{con.id}}">
								{{con.name}}
							</option>
						</select>
						<div class="error-message message-small"
							*ngIf="!createinformation.get('country').valid && createinformation.get('country').touched">
							Please enter Country
						</div>
					</div>
					<div class="form-group">
						<label for="partner-priority">Priority </label>
						<select name="priority" id="prior_r" class="form-control" formControlName="priority">
							<option [ngValue]="null" selected>Select Priority</option>
							<option *ngFor="let prior of priorityList" value="{{prior.id}}">
								{{prior.priority}}
							</option>
						</select>
						<div class="error-message message-small"
							*ngIf="!createinformation.get('priority').valid && createinformation.get('priority').touched">
							Please enter Priority
						</div>
					</div>
					<div class="form-group">
						<label for="partner-requestType">Support Request Type </label>

						<select name="requestType" id="requestType_r" class="form-control"
							formControlName="requestType">
							<option [ngValue]="null" selected>Select Support Request Type</option>
							<option *ngFor="let type of supportRequestTypeList" value="{{type.id}}">
								{{type.type}}
							</option>
						</select>
						<div class="error-message message-small"
							*ngIf="!createinformation.get('requestType').valid && createinformation.get('requestType').touched">
							Please enter Support Request Type
						</div>
					</div>

					<div class="form-group">
						<label for="partner-name">Subject</label>
						<input type="text" class="form-control" id="partner-name" formControlName="subject">
						<div class="error-message message-small"
							*ngIf="!createinformation.get('subject').valid && createinformation.get('subject').touched">
							Please enter Subject
						</div>
					</div>


					<div class="form-group">
						<label>Message</label>

						<!-- <kendo-editor [value]="value" formControlName="messages" style="height: 250px;"></kendo-editor> -->

						<textarea class="form-control" id="richTextAreacreated" formControlName="messages"
							(keydown)="onMessageSend($event)" #chat_message></textarea>

					</div>






					<div class="form-group">
						<label>File Upload </label>
						<div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop
							(onFileDropped)="uploadFiless($event)">
							<input hidden type="file" #fileInput (change)="uploadFile($event)">
						</div>
						<div class="files-list" *ngFor="let file of files;let i= index">
							<p> {{ file }} </p>
							<button class="delete-file" (click)="deleteAttachment(i)">
								<a data-toggle="tooltip" title="View" class="btn btn-danger">
									<i class="far fa-trash-alt"></i>
								</a>
							</button>
						</div>
					</div>

				</form>

			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" id="addCustomerSave" (click)="finishFunction()">
					Submit
				</button>
				<button type="button" class="btn btn-dark" data-dismiss="modal">
					Cancel
				</button>

			</div>
		</div>
	</div>
</div>
<!-- Create Ticket Modal End -->

<!--------------------------------------
Ticket Table View
---------------------------------------->

<div id="table_view">
	<div class="card ticket-table-view">
		<div class="card-body p-0">
			<div id="loading" class="loading-hide"></div>
			<table class="table table-striped table-md" style="color: #000;">

				<tr class="ticket-table-header">

					<th></th>
					<th>Ticket Number</th>
					<th>Subject</th>
					<th>Status</th>
					<th>Department</th>
					<th>Customer</th>
					<th>Action</th>

				</tr>
				<tbody>
					<tr *ngFor="let l of tickets;let i = index">
						<td><input type="checkbox" name="emailtickets" class="emailtickets" name="checkbox"></td>
						<td style="font-weight: 700;">
							#{{l.ticket_no}}
						</td>
						<td>
							<a href="javascript:;" class="pointer fl" style="font-weight: 700;"
								(click)="gotck(l.ticket_no)">
								<span>{{l.ticket_subject}}
								</span>
								<div style="font-size: 12px;color: gray;" clsass="ticket-id dark-grey-clr">
									{{l.created_dt}}
								</div>
							</a>
						</td>
						<td style="width: 10%;">
							<div class="status-tag-wrap status-wrapper">
								<span>
									{{l.status_desc}}
								</span>
							</div>
						</td>
						<td style="width: 15%;">
							{{l.department_name}}
						</td>
						<td style="width: 25%;">
							{{l.ticket_from}}
						</td>
						<td>
							<a (click)="gotck(l.ticket_no)" data-toggle="tooltip" title="View"
								class="btn btn-danger btn-sm">
								<i class="fas fa-eye"></i> View Ticket
							</a>
						</td>
					</tr>
					<!-- No Data -->
					<tr *ngIf="tickets && tickets.length === 0">
						<td colspan="7" class="text-center">
							<div style="padding: 30px; color: #999; font-weight: 600;">
								No Ticket Found
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>

<!--------------------------------------
Ticket Table View End
---------------------------------------->